/**
 * Volume-reconcile module manifest (request 0196).
 *
 * `scanLimit` is org-wide operational cost — not a per-user toggle. The key
 * `volumereconcile` matches Module.actionProperties.redirectTo.
 */
export const VOLUME_RECONCILE_DEFAULT_SCAN_LIMIT = 500;
export const VOLUME_RECONCILE_MAX_SCAN_LIMIT = 2000;
export const volumeReconcileManifest = {
    key: 'volumereconcile',
    version: 1,
    name: 'Conciliação de volumes',
    parameters: [
        {
            key: 'scanLimit',
            label: 'Limite da varredura',
            type: 'number',
            scope: 'module+org',
            default: VOLUME_RECONCILE_DEFAULT_SCAN_LIMIT,
        },
    ],
};
//# sourceMappingURL=volumeReconcile.manifest.js.map